import React from 'react';
import {
    Col,
    FormGroup,
    FormLabel,
    Form,
    Button,
} from 'react-bootstrap';
import {
    Card,
    InputPassword,
    LoaderBtn,
    Checkbox,
} from 'components';
import { personalDataProcessingPolicy } from '_helpers';
import _ from 'lodash';

const AccountConfirmation = ({
    handleSubmit, cleanErrors, apiError, authProcessing, onLogin,
}: IProps) => {
    const InitFormData: FormData = {
        password: '',
        personalChecked: false,
    };

    const initTokenError: IError = {
        text: '',
    };

    const initPasswordError: IError = {
        text: '',
    };

    const [tokenError, setTokenError] = React.useState(initTokenError);
    const [passwordError, setPasswordError] = React.useState(initPasswordError);
    const [formData, setFormData] = React.useState(InitFormData);

    React.useEffect(() => {
        const getFieldErrorFromApiError = (fieldName: string, errors: ApiError | null) => {
            if (!errors || !errors.failures) return '';
            if (_.has(errors.failures, fieldName)) {
                return {
                    text: errors.failures[fieldName].join(', '),
                    code: errors.code,
                };
            }
            return '';
        };

        const passwordErrors = getFieldErrorFromApiError('password', apiError);
        const tokenErrors = getFieldErrorFromApiError('token', apiError);

        if (tokenErrors && tokenErrors.text) {
            setTokenError({
                text: tokenError.text,
                code: tokenError.code,
            });
        }

        if (passwordErrors) {
            setPasswordError({
                text: passwordErrors.text,
                code: passwordErrors.code,
            });
        }
    }, [apiError]);

    const checkValidationErrors = (data: FormData) => {
        const passwordErrorValid = data.password.length > 5 ? '' : 'Пароль не должен быть короче 6 символов';

        return {
            password: passwordErrorValid,
        };
    };

    const submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const validResult = checkValidationErrors(formData);
        cleanErrors();

        if (validResult.password.length > 0) {
            setPasswordError({ text: validResult.password });
        } else {
            await handleSubmit(formData.password);
        }
    };

    const handleToggleCheck = (targetNodeName: string) => {
        if (targetNodeName !== 'DIV' && targetNodeName !== 'LABEL') return;
        setFormData({ ...formData, personalChecked: !formData.personalChecked });
    };

    const handleInputChange = (event: React.ChangeEvent<any>) => {
        cleanErrors();
        setTokenError(initTokenError);
        setPasswordError(initPasswordError);
        setFormData({ ...formData, [event.target.name]: event.target.value });
    };

    return (
        <Col className="auth-forms--container">
            <Card
              hidden={false}
              title="Подтверждение учетной записи"
              ftTextCenter
            >
                <form onSubmit={submit}>
                    <div className="sub-title">Для подтверждения учетной записи необходимо установить новый пароль</div>

                    {apiError && tokenError.text.length === 0 && passwordError.text.length === 0 ? (
                        <>
                            <Form.Control.Feedback className="d-inline-block" type="invalid">
                                {apiError.message}
                            </Form.Control.Feedback>
                            {apiError.type === 'alreadyExists' && (
                                <Button
                                  className="mt-3"
                                  variant="primary"
                                  type="button"
                                  onClick={() => {
                                        cleanErrors();
                                        onLogin();
                                    }}
                                >
                                    Войти
                                </Button>
                            )}
                        </>
                    ) : (
                            <>
                                {!tokenError.text.length ? (
                                    <FormGroup>
                                        <FormLabel>Пароль</FormLabel>
                                        <InputPassword
                                          name="password"
                                          onChange={handleInputChange}
                                          isInvalid={passwordError.text.length > 0}
                                        />
                                        <Form.Control.Feedback className="d-inline-block" type="invalid">
                                            {passwordError.text}
                                        </Form.Control.Feedback>
                                    </FormGroup>
                                ) : null}

                                {tokenError.text.length ? (
                                    <Form.Control.Feedback className="d-inline-block" type="invalid">
                                        {tokenError.text}
                                    </Form.Control.Feedback>
                                ) : null}

                                <div className="required-checkboxes-container">
                                    <div
                                      className="mb-4"
                                      onClick={(e: any) => handleToggleCheck(e.target.nodeName)}
                                      data-test-first-checkbox
                                    >
                                        <Checkbox
                                          checked={formData.personalChecked}
                                          number="1"
                                        />
                                        <label>
                                            Я выражаю свое согласие на обработку моих персональных данных в
                                            соответствии с
                                          <a target="__blank" style={{ display: 'block' }} href={personalDataProcessingPolicy}>
                                                Политикой обработки и защиты
                                                персональных данных
                                          </a>
                                        </label>
                                    </div>
                                </div>

                                {!tokenError.text.length ? (
                                    <LoaderBtn loading={!!authProcessing} disabled={!formData.personalChecked} variant="primary" type="submit">
                                        Подтвердить и Войти
                                    </LoaderBtn>
                                ) : null}
                            </>
                        )}
                </form>
            </Card>
        </Col>
    );
};

export interface IProps {
    apiError: ApiError | null;
    authProcessing: boolean;
    onLogin: () => void;
    handleSubmit: (password: string) => void;
    cleanErrors: () => void;
}

interface ApiError {
    message: string;
    code: number;
    failures?: { [key: string]: string[] };
    type: string;
}

interface FormData {
    password: string;
    personalChecked?: boolean;
}

interface IError {
    text: string;
    code?: number;
}


export default AccountConfirmation;
